import React from "react";
import styled from "styled-components";

const FieldSetStyle = styled.fieldset`
  background-color: gray;
`;

const FieldSet = ({ legend, children }) => {
  return (
    <FieldSetStyle>
      <legend>{legend}</legend>
      {children}
    </FieldSetStyle>
  );
};

export default FieldSet;
